import { render } from "./KcpPaymentForm.vue?vue&type=template&id=a2c5f84e"
import script from "./KcpPaymentForm.vue?vue&type=script&lang=js"
export * from "./KcpPaymentForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__